@if (offers()?.length) {
  <div
    id="offer-container"
    class="offer-container"
    data-testid="slotcom-shop-offer-button"
    theming
    themingGroup="portal"
    [themingAsset]="offers().length === 1 ? 'shop-button-offer' : 'shop-button-offers'"
    (click)="openMessageDeal()">
    @if (offers() && offers().length > 1) {
      <slotcom-badge [value]="offers().length"></slotcom-badge>
    }
    <div class="info-row">
      <div class="info-content">
        <div class="reward-display">
          @if (offers().length > 1) {
            <span>{{ 'home.shop.offer.offers' | translate | uppercase }}</span>
          } @else {
            <span>{{ 'home.shop.offer.offer' | translate | uppercase }}</span>
          }
        </div>
      </div>
    </div>

    <slotcom-animated-timer
      [showIcon]="true"
      [showInDays]="true"
      [endDate]="offers()[0].expirationDate"></slotcom-animated-timer>
  </div>
}
